module.exports = __webpack_public_path__ + "static/media/node.b1fe0968.png";